// extracted by mini-css-extract-plugin
export default {"appRoot":"_2ncZs"};